import { apiClient } from "./apiClient";
import type { ApiResponse } from "./types";
import { unwrapApiResponse } from "../shared/utils/apiResponse";

export type EntryDraftModuleKey = "DailyEntry" | "CashEntry" | "SalesInvoice" | "PurchaseInvoice" | "ReceiptVoucher" | "PaymentVoucher";

export type EntryDraftRecord = {
  id: number;
  moduleKey: EntryDraftModuleKey;
  title: string;
  payload: any;
  createdAt: string;
  updatedAt: string;
};

export type EntryDraftSubmitResult = {
  moduleKey: EntryDraftModuleKey;
  entityId?: number | null;
  affectedCount?: number | null;
};

export async function getDrafts(moduleKey: EntryDraftModuleKey) {
  const { data } = await apiClient.get<ApiResponse<EntryDraftRecord[]>>("/entry-drafts", { params: { moduleKey } });
  return unwrapApiResponse(data);
}

export async function createDraft(payload: { moduleKey: EntryDraftModuleKey; title: string; payload: any }) {
  const { data } = await apiClient.post<ApiResponse<EntryDraftRecord>>("/entry-drafts", payload);
  return unwrapApiResponse(data);
}

export async function updateDraft(id: number, payload: { moduleKey: EntryDraftModuleKey; title: string; payload: any }) {
  const { data } = await apiClient.put<ApiResponse<EntryDraftRecord>>(`/entry-drafts/${id}`, payload);
  return unwrapApiResponse(data);
}

export async function deleteDraft(id: number) {
  await apiClient.delete(`/entry-drafts/${id}`);
}

export async function submitDraft(id: number, payload?: any) {
  const { data } = await apiClient.post<ApiResponse<EntryDraftSubmitResult>>(`/entry-drafts/${id}/submit`, payload === undefined ? {} : { payload });
  return unwrapApiResponse(data);
}
